import React from 'react'

export default function GalleryImages({
    images
}) {

    return (
        <div className='flex'>
            {images?.map((item, index) => {
                return (
                    <div className='w-100 h-100 rounded-lg border border-line bg-cover bg-center' key={index}  style={{backgroundImage: `url(${item})`}}>
                        </div>
                )
            })}
        </div>
    )
}
